import React from 'react';
import TinySlider from "tiny-slider-react";
import { Fancybox } from "@fancyapps/ui";
import 'tiny-slider/dist/tiny-slider.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const tickets = [
    { img: '24-06-15-bahiablanca', url: 'oYxNNdaRYdA' },
    { img: '24-07-13-azul', url: 'hkO1T1GmlGU' },
    { img: '24-07-27-tandil', url: 'kQv5dL0V58E' },
    { img: '24-08-10-suipacha', url: 'ORC5uuFipJI' },
    { img: '24-08-24-salliquelo', url: '2YH5LEfXem4' },
    { img: '24-09-14-colon', url: 'XCQ6d38ACyA' },
    { img: '24-09-28-gralpinto', url: 'yCe1WDcehsk' },
    { img: '24-10-19-exaltacion', url: 'zTCJO4WzwGU' },
    { img: '24-11-16-ranchos', url: 'j4zZ2b7IXF8' },
    { img: '24-11-30-laplata', url: 'G0ToxldHhQo' }
]



const settings = {
  lazyload: true,
  nav: false,
  mouseDrag: true,
  items: 1,
  gutter: 25,
  autoplayButton: false,
  autoplayButtonOutput: false,
  speed: 300,
  autoplay: true,
  edgePadding: 15,
  autoplayTimeout: 2500,
  autoHeight: true,
  controlsText: ['<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'],
  responsive: {
    480: {
      items: 2
    },
    768: {
      items: 3
    }
  }
};

export default function Tickets() {
  Fancybox.bind("[data-fancybox]", {
    Thumbs: false,
  });

  return (
    <div className="tickets">
      <h4>Elegí un ticket para ver el video de la jornada</h4>
      <a href="https://www.youtube.com/playlist?list=PLjue-8AdQIWAh-ea2XUj_mlk2lcL62CZr" target='blank' className='playlist'>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 14L3 14" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"/><path d="M11 18H3" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"/><path d="M18.875 14.1183C20.5288 15.0732 21.3558 15.5506 21.4772 16.2394C21.5076 16.4118 21.5076 16.5881 21.4772 16.7604C21.3558 17.4492 20.5288 17.9266 18.875 18.8815C17.2212 19.8363 16.3942 20.3137 15.737 20.0745C15.5725 20.0147 15.4199 19.9265 15.2858 19.814C14.75 19.3644 14.75 18.4096 14.75 16.4999C14.75 14.5902 14.75 13.6354 15.2858 13.1858C15.4199 13.0733 15.5725 12.9852 15.737 12.9253C16.3942 12.6861 17.2212 13.1635 18.875 14.1183Z" stroke="#FFFFFF" stroke-width="1.5"/><path d="M3 6L13.5 6M20 6L17.75 6" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"/><path d="M20 10L9.5 10M3 10H5.25" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round"/></svg>
      </a>
      <div className="tns-gallery">
        <TinySlider settings={settings}>
          {tickets.map((el, index) => (
            <div key={index}>
              <a data-fancybox href={`https://www.youtube.com/watch?v=${el.url}`}>
                <img className={`tns-lazy-img`} data-src={`/tickets/${el.img}.png`} alt="" />
              </a>
            </div>
          ))}
        </TinySlider>
      </div>
    </div>
  );
}
